import React, { JSX, ReactNode, createContext, useState } from 'react';

export interface FormState {
  formType: string;
}
interface FormContextProps {
  FormState: FormState;
  setFormState: React.Dispatch<React.SetStateAction<FormState>>;
}
interface FormTypeProviderProps<T extends ReactNode> {
  children: T;
}

const FormContext = createContext<FormContextProps | undefined>(undefined);

export const FormTypeProvider = <T extends ReactNode>({
  children,
}: FormTypeProviderProps<T>): JSX.Element => {
  const [FormState, setFormState] = useState<FormState>({
    formType: '',
  });

  return (
    <FormContext value={{ FormState, setFormState }}>{children}</FormContext>
  );
};

export default FormContext;
